@file:OptIn(InternalResourceApi::class)

package fr.frux.core.designsystem.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/fr.frux.core.designsystem.resources/"

@delegate:ResourceContentHash(2_070_572_209)
public val Res.font.figtree_medium: FontResource by lazy {
      FontResource("font:figtree_medium", setOf(
        ResourceItem(setOf(), "${MD}font/figtree_medium.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(456_327_434)
public val Res.font.figtree_regular: FontResource by lazy {
      FontResource("font:figtree_regular", setOf(
        ResourceItem(setOf(), "${MD}font/figtree_regular.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_070_364_006)
public val Res.font.figtree_semibold: FontResource by lazy {
      FontResource("font:figtree_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/figtree_semibold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(563_469_677)
public val Res.font.sora_bold: FontResource by lazy {
      FontResource("font:sora_bold", setOf(
        ResourceItem(setOf(), "${MD}font/sora_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(33_283_804)
public val Res.font.sora_semibold: FontResource by lazy {
      FontResource("font:sora_semibold", setOf(
        ResourceItem(setOf(), "${MD}font/sora_semibold.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("figtree_medium", Res.font.figtree_medium)
  map.put("figtree_regular", Res.font.figtree_regular)
  map.put("figtree_semibold", Res.font.figtree_semibold)
  map.put("sora_bold", Res.font.sora_bold)
  map.put("sora_semibold", Res.font.sora_semibold)
}
